import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { getAllMyAppsListInfo } from '@reducers/service/serviceThunk';
import { gameProviderTypes } from '@configs/layout';
import { deleteMyAppInAppInfoList } from '@reducers/service/serviceThunk';
import { IAllMyAppListObj } from '@models/manager/service/serviceModel';

import CompetitorManagerPopup from '@components/template/appManage/competitorManagerPopup';

// add 시 여기 오기 전  리스트 요청 처리 할 것!
// step2 : addCompetitorsApp 에서 myAppInfoList 요청하기!
const ManageMyApps = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const { myAppInfoList, allMyAppListInfo } = useSelector(({ serviceManager }: RootState) => serviceManager);
  const { myAppObj } = useSelector(({ LAYOUT }: RootState) => LAYOUT);

  // competitor Manager Popup toggle Data
  const [toggleData, setToggleData] = useState<null | IAllMyAppListObj>(null);

  // useEffect for AllMyAppList 요청
  useEffect(() => {
    // null 일땐 요청!
    if (allMyAppListInfo === null) {
      dispatch(getAllMyAppsListInfo({ userId: 'ss' }));
    }
  }, [allMyAppListInfo]);

  // useEffect for checkData log
  useEffect(() => {}, [allMyAppListInfo]);

  // useCallback for delete one app of user's appList
  const onClickDeleteMyApp = useCallback(
    ({ appId, providerType, appSeq }: { appId: string; providerType: string; appSeq: string | number }) => {
      dispatch(
        deleteMyAppInAppInfoList({
          appId: appId,
          providerType: providerType,
          userId: 'ss',
          appSeq: appSeq,
        })
      );
    },
    [dispatch, deleteMyAppInAppInfoList]
  );

  // useCallback for competitorApps manager popup handler
  const onClickPopupHandler = useCallback((popupData: null | IAllMyAppListObj) => {
    setToggleData(popupData);
  }, []);

  // useCallbakc for new App button
  const onClickNewApp = useCallback(() => {
    navigate('/appManager/myApps/addMyApp');
  }, [navigate]);

  return (
    <>
      {/* 컴포넌트 꼭대기 부분 */}
      <div className="account-header">
        <h2 className="account-tit">Manage your Apps</h2>
        <button type="button" className="btn-b pri" onClick={onClickNewApp}>
          <span className="material-icons">add</span>
          New App
        </button>
      </div>
      {/* 컴포넌트 테이블 부분 */}
      <div className="tb-basic-wrap">
        <div className="tb-basic-inner">
          <table>
            <colgroup>
              <col />
              <col />
              <col />
              <col width="150" />
            </colgroup>
            <thead>
              <tr>
                <th scope="row">My Apps</th>
                <th scope="row">Store Integration</th>
                <th scope="row">Competitor Apps</th>
                <th scope="row">Delete</th>
              </tr>
            </thead>
            <tbody>
              {myAppObj &&
                allMyAppListInfo &&
                allMyAppListInfo.length > 0 &&
                allMyAppListInfo.map((appObj, index) => (
                  <tr key={index}>
                    <td>
                      <div className="manage-appModule">
                        {/* 아래의 on 부분이 현재 내가 선택한 앱 표시 */}
                        <div
                          className={`app-name-click ${
                            appObj?.myAppInfo?.appId === myAppObj?.appId &&
                            appObj?.myAppInfo?.providerType === myAppObj?.providerType
                              ? 'on'
                              : ''
                          }`}
                        >
                          <div className="app-name-img">
                            <img src={appObj?.myAppInfo?.icon} alt="" />
                          </div>
                          <div className="app-name-txt">
                            <h2 className="app-name-tit">{appObj?.myAppInfo?.title}</h2>
                            <p className="app-name-dsc">
                              <i
                                className={`app_icon ${
                                  appObj?.myAppInfo?.providerType === gameProviderTypes.GooglePlayStore
                                    ? 'google'
                                    : 'apple'
                                }`}
                              ></i>
                              {appObj?.myAppInfo?.developer}
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      {/* 스토어 integration 체크부분 */}
                      {/* {appObj?.IsConnectStoreIntegration ? (
                        <div className="store_connect ok">
                          <span className="material-icons">link</span>
                          Connected
                        </div>
                      ) : ( */}
                      <div className="store_connect not">
                        <span className="material-icons">link_off</span>
                        Not Connected
                      </div>
                      {/* )} */}
                    </td>
                    <td>
                      <div>
                        <div className="add_applist_bx">
                          <ul>
                            {appObj?.myCompetitorAppsInfo &&
                              appObj?.myCompetitorAppsInfo.length > 0 &&
                              appObj.myCompetitorAppsInfo.map((compAppObj, index) => (
                                <li key={index}>
                                  <img src={compAppObj?.icon} alt="" />
                                </li>
                              ))}
                          </ul>
                          <button type="button" className="app_add_btn" onClick={() => onClickPopupHandler(appObj)}>
                            <i></i>
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div>
                        <button
                          type="button"
                          className="dropdown_bx"
                          onClick={() =>
                            onClickDeleteMyApp({
                              appId: appObj?.myAppInfo?.appId,
                              providerType: appObj?.myAppInfo?.providerType,
                              appSeq: appObj?.myAppInfo?.appSeq,
                            })
                          }
                        >
                          <span className="material-icons">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* 아래는 competitorApps Manager Popup 부분 */}
      {toggleData && <CompetitorManagerPopup selectedMyAppInfo={toggleData} popupHandler={onClickPopupHandler} />}
    </>
  );
};

export default ManageMyApps;
